import React, { ReactNode, Suspense, useEffect, useState } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Landing from "../Pages/Landing";
import MyAppBar from "../Components/Bar/MyAppBar";
import SignUp from "../Pages/SignUp";
import SignIn from "../Pages/SignIn";
import Verification from "../Pages/Verification";
import { useDispatch, useSelector } from "react-redux";
import { setPrevious } from "../Redux/TourSlice";
import { RootState } from "../Redux/UserSlice";
import { cookies } from "../Controller/Common";
import { ROUTE_CONFIG } from "./Config";
import ErrorPage from "../Pages/Landing/ErrorPage";

interface ProtectProps {
  children: ReactNode;
  roles?: any;
}

const Nav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [current, setCurrent] = useState("");
  const userRole = useSelector((state: RootState) => state.user.role);
  const token = cookies.get("token");
  const userId = cookies.get("userId");

  useEffect(() => {
    if (location.pathname === "/landing" && userRole !== "CREATOR") {
      navigate("/landing/activity");
    } else if (location.pathname === "/landing" && userRole === "CREATOR") {
      navigate("/landing/CreateCourseAndModule");
    }
    if (location.pathname === "/") {
      navigate("/signup");
    }
  }, [location, navigate, userRole]);

  useEffect(() => {
    setCurrent(location.pathname);
    dispatch(setPrevious(current));
  }, [location.pathname, current, dispatch]);

  useEffect(() => {
    if (location.pathname.startsWith("/landing") && !token && !userId) {
      navigate("/signin");
    }
  }, [location.pathname, navigate, token, userId]);

  useEffect(() => {
    if (location.pathname !== "/landing/Content") {
      const handleCopyPaste = (event: ClipboardEvent) => {
        event.preventDefault();
      };

      const listener = handleCopyPaste as unknown as EventListener;

      window.addEventListener("copy", listener);
      window.addEventListener("cut", listener);
      window.addEventListener("paste", listener);

      return () => {
        window.removeEventListener("copy", listener);
        window.removeEventListener("cut", listener);
        window.removeEventListener("paste", listener);
      };
    }
  }, [location]);

  return null;
};

const Protect: React.FC<ProtectProps> = React.memo(({ children, roles }) => {
  const auth = useSelector((state: RootState) => state.user.isAuth);
  const userRole = useSelector((state: RootState) => state.user.role);
  const token = cookies.get("token");
  const role = cookies.get("role");
  if (!auth && !token) {
    return <Navigate to="/signin" replace />;
  }

  if (roles && !roles.includes(role || userRole)) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
});

export default function MyRoutes() {
  return (
    <>
      <BrowserRouter>
        <Nav />
        <MyAppBar />
        <Suspense fallback={<></>}>
          <Routes>
            <Route path="*" element={<ErrorPage />} />
            <Route path="signup" element={<SignUp />} />
            <Route path="signin" element={<SignIn />} />
            <Route path="verification" element={<Verification />} />
            <Route
              path="/landing"
              element={
                <Protect>
                  <Landing />
                </Protect>
              }
            >
              {ROUTE_CONFIG.map(({ path, component: Component, roles }) => (
                <Route
                  path={path}
                  element={
                    <Protect roles={roles}>
                      <Component />
                    </Protect>
                  }
                />
              ))}
            </Route>
          </Routes>{" "}
        </Suspense>
      </BrowserRouter>
    </>
  );
}
 